import http from "../AppConfig";
import {Encrypt} from "@/plugins/cryptojs";

const groupName = window.location.hostname.slice(
    0,
    window.location.hostname.indexOf(".", 0)
);

const c = encodeURIComponent(Encrypt(groupName));

class MasterSettingsService {
  getAll(duplicate, hash) {
    return http.get(`masters?duplicate=${duplicate}&hash=${hash}&c=${c}`);
  }

  saveMasters(masters, hash, token) {
    return http.post(`masters?hash=${hash}&c=${c}`, masters, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  resetMasters(hash, token) {
    return http.get(`masters/reset?hash=${hash}&c=${c}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  getMastersByCategorySetting(keys, hash) {
    return http.post(`masters/list?hash=${hash}&c=${c}`, keys);
  }

  deleteMaster(id, hash, token){
    return http.delete(`masters/${id}?hash=${hash}&c=${c}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}

export default new MasterSettingsService();
